import type { AxiosRequestConfig } from 'axios';
import { Page } from '@/shared/api/pagination';
import type {
  UserAttribute,
  UserAttributeCreate,
} from '@/entities/user/user-attribute';
import { authInstance } from '@/shared/api/api-instances/auth/api-instance';

export class UserAttributesAPI {
  static getUserAttributes(options?: AxiosRequestConfig) {
    return authInstance.get<UserAttribute[]>(`/users/attribute`, options);
  }

  static deleteUserAttribute(id: string, options: AxiosRequestConfig = {}) {
    return authInstance.delete(`/users/attribute/${id}`, options);
  }

  static getAttributes(options?: AxiosRequestConfig) {
    return authInstance.get<Page<UserAttribute>>(`/attributes`, {
      ...options,
    });
  }

  static createAttribute(
    payload: UserAttributeCreate,
    options?: AxiosRequestConfig,
  ) {
    return authInstance.post<UserAttribute>(`/attribute`, payload, options);
  }

  static getValueTypesOperators(options?: AxiosRequestConfig) {
    return authInstance.get(`/attributes/value_types_operators`, options);
  }

  static getAttribute(id: string, options?: AxiosRequestConfig) {
    return authInstance.get<UserAttribute>(`/attribute/${id}`, options);
  }

  static updateAttribute(
    id: string,
    payload: UserAttributeCreate,
    options?: AxiosRequestConfig,
  ) {
    return authInstance.put<UserAttribute>(
      `/attribute/${id}`,
      payload,
      options,
    );
  }

  static deleteAttribute(id: string, options?: AxiosRequestConfig) {
    return authInstance.delete(`/attribute/${id}`, options);
  }
}